import { Col } from 'antd';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { useRuntimeConfig } from '../../../runtimeConfig';
import { useThemeComponents } from '../../../themes';
import colSpan from '../../shared/ApplicationDetailsPage/standard/colSpan';
import ApplicationDetailsPanel from '../../shared/ApplicationDetailsPage/standard/Panel';
import SectionKey from '../../shared/ApplicationDetailsPage/standard/SectionKey';
import { type TradeInApplicationFormValues } from './TradeInForm';

const TradeInVehiclePanel = () => {
    const { t } = useTranslation('tradeInDetails');
    const {
        FormFields: { DisplayField },
    } = useThemeComponents();

    const { instance } = useRuntimeConfig();
    const { values } = useFormikContext<TradeInApplicationFormValues>();

    return (
        <ApplicationDetailsPanel
            header={t('tradeInDetails:panels.application.tradeIn.header')}
            name={SectionKey.TradeInVehicles}
            defaultExpanded
        >
            <Col {...colSpan}>
                <DisplayField
                    {...t('tradeInDetails:fields.vehicle.no', { returnObjects: true })}
                    value={values.licensePlateNumber}
                    disabled
                />
            </Col>
            <Col {...colSpan}>
                <DisplayField
                    {...t('tradeInDetails:fields.vehicle.make', { returnObjects: true })}
                    value={values.vehicleMake}
                    disabled
                />
            </Col>
            <Col {...colSpan}>
                <DisplayField
                    {...t('tradeInDetails:fields.vehicle.model', { returnObjects: true })}
                    value={values.vehicleModel}
                    disabled
                />
            </Col>
            <Col {...colSpan}>
                <DisplayField
                    {...t('tradeInDetails:fields.vehicle.manufacturingYear', { returnObjects: true })}
                    value={values.manufacturingYear}
                    disabled
                />
            </Col>
            <Col {...colSpan}>
                <DisplayField
                    {...t('tradeInDetails:fields.vehicle.selectedDealer', { returnObjects: true })}
                    value={values.selectedDealer?.dealerName}
                    disabled
                />
            </Col>
            {instance !== 'audi' && (
                <Col {...colSpan}>
                    <DisplayField
                        {...t('tradeInDetails:fields.vehicle.offerPrice', { returnObjects: true })}
                        value={values.selectedDealer?.offerValue}
                        disabled
                    />
                </Col>
            )}
        </ApplicationDetailsPanel>
    );
};

export default TradeInVehiclePanel;
